import * as React from "react";
import { IconButton, styled, Tooltip } from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import ImportantDevicesIcon from "@mui/icons-material/ImportantDevices";
import BugReportIcon from "@mui/icons-material/BugReport";
import FastForwardIcon from "@mui/icons-material/FastForward";
import SettingsIcon from "@mui/icons-material/Settings";
import { useClinicState } from "../../../clinic/clinicStateContext";
//region [[ Styles ]]

const ClinicEnvQuickLinksView = styled("div")({
  padding: "0 15px",
  display: "flex",
  flexFlow: "row",
  justifyContent: "space-evenly",
  width: "100%",
  alignItems: "center",
});

const LinkButton = styled(IconButton)({
  // "& svg": {
  //   fill: "white",
  // },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicEnvQuickLinksProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

enum Environments {
  DEV = "dev",
  PROD = "prod",
  LOCAL = "local",
  STAGE = "staging",
}

export const ClinicEnvQuickLinks = ({ ...props }: ClinicEnvQuickLinksProps) => {
  const [
    {
      clinicData: { id },
    },
  ] = useClinicState();

  const goToClinic = (env: Environments) => {
    let url;
    if (env === Environments.LOCAL) {
      url = "http://localhost:3003";
    } else if (env === Environments.DEV) {
      url = "https://patient-dev.kahun.com";
    } else if (env === Environments.STAGE) {
      url = "https://patient-staging.kahun.com";
    } else {
      url = "https://patient.kahun.com";
    }
    window.open(`${url}/clinic/${id}/welcome?noCache`);
  };

  return (
    <ClinicEnvQuickLinksView>
      <Tooltip title={"Open in localhost"}>
        <LinkButton onClick={() => goToClinic(Environments.LOCAL)}>
          <CodeIcon />
        </LinkButton>
      </Tooltip>
      <Tooltip title={"Open in dev"}>
        <LinkButton onClick={() => goToClinic(Environments.DEV)}>
          <BugReportIcon />
        </LinkButton>
      </Tooltip>
      <Tooltip title={"Open in staging"}>
        <LinkButton onClick={() => goToClinic(Environments.STAGE)}>
          <FastForwardIcon />
        </LinkButton>
      </Tooltip>
      <Tooltip title={"Open in prod"}>
        <LinkButton onClick={() => goToClinic(Environments.PROD)}>
          <ImportantDevicesIcon />
        </LinkButton>
      </Tooltip>
      <Tooltip title={"Settings"}>
        <LinkButton onClick={() => window.open("/settings/")}>
          <SettingsIcon />
        </LinkButton>
      </Tooltip>
    </ClinicEnvQuickLinksView>
  );
};
